// extracted by mini-css-extract-plugin
export default {"point":"JobItem_point__wWPLc"};